import { MenuHeading } from './MenuHeading';

// TODO: in v9, move styled() from MenuHeading.jsx to here
export var StyledMenuHeading = MenuHeading;